// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__XuWp9"};